import { render, staticRenderFns } from "./CarouselBase.vue?vue&type=template&id=96798b1c&scoped=true&"
import script from "./CarouselBase.vue?vue&type=script&lang=js&"
export * from "./CarouselBase.vue?vue&type=script&lang=js&"
import style0 from "./CarouselBase.vue?vue&type=style&index=0&id=96798b1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96798b1c",
  null
  
)

export default component.exports